import {fetchSettingsSuccess, globalError} from "modules/actions";
import {viewWinModalSuccess} from "modules/actions/user";
import Api from "modules/utils/Api";
import ApiError from "modules/utils/Api/ApiError";
import {put} from "typed-redux-saga";
import {call} from "typed-redux-saga/macro";

export const fetchSettingSaga = function* () {
    const result = yield* call(Api.Jsons.settings);
    if (result.data) {
        yield* put(fetchSettingsSuccess(result.data));
    }
};

export const viewWinModalSaga = function* () {
    try {
        const result = yield* call(Api.User.view_win_modal);

        ApiError.CHECK(result.data);

        yield* put(viewWinModalSuccess(result.data.success));
    } catch (e) {
        yield* put(globalError(e));
    }
}
